module.exports = __webpack_public_path__ + "db4012dd1fd4d2cf8eada68f3369db78.png";